import { useCallback, useEffect, useState } from "react";

import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "@/redux/store";

import { Loader2 } from "lucide-react";
import { getGroupTreeMap } from "../../api/group.api";
import SearchBar from "../../components/SearchBar/SearchBar";
import { setTreeMap } from "../../group";
import { renderTreemap } from "../../lib/treemap";
import CreateChildGroup from "./component/CreateChildGroup";

const TreeOrg = () => {
  const dispatch = useAppDispatch();
  const {
    data: groupData,
    showCreateGroupChildModal,
    groupSelected,
  } = useAppSelector((state) => state.group);
  const { treeMap } = useAppSelector((state) => state.group);
  const { id = "" } = useParams();
  const [loading, setLoading] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const fetchGroupTreemap = useCallback(async () => {
    if (!id || !groupData?.id) {
      return;
    }
    try {
      setLoading(true);
      const result = await getGroupTreeMap(id);
      dispatch(setTreeMap(result.data.sort((a, b) => a.groupId - b.groupId)));
    } catch {
      toast.error("Tải dữ liệu thất bại");
    } finally {
      setLoading(false);
    }
  }, [id, dispatch, groupData]);
  useEffect(() => {
    fetchGroupTreemap();
    return () => {
      dispatch(setTreeMap([]));
    };
  }, []);
  useEffect(() => {
    if (treeMap) {
      renderTreemap("#treemap", treeMap);
    }
  }, [treeMap]);

  return (
    <div>
      {showCreateGroupChildModal && groupSelected && (
        <CreateChildGroup
          rootId={groupSelected.groupId}
          rootMode={groupData?.mode}
        />
      )}
      <div className="relative overflow-x-hidden">
        {showSearchBar && <SearchBar onClose={() => setShowSearchBar(false)} />}
        {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        <div
          id="treemap"
          className="w-full h-[calc(100vh-70px-85px-120px)]"
        ></div>
      </div>
    </div>
  );
};

export default TreeOrg;
